import { getRSqlBySearch } from '@helpers'
import {
  ACTION_CODE,
  AGGREGATION_COMMAND_RESULT_EXAMPLE,
  EVENT_CODE,
  ROSTER_DUTY_DEFAULT_FILTER_EXAMPLE,
} from '@constants'
import { ActionJSScriptConfig, FormCommand } from '@types'

type Props = {
  eventCode?: EVENT_CODE | null
  actionCode?: ACTION_CODE
  command?: FormCommand[] | null
}

export const getTimelineJSFieldScriptConfig = (data: Props): ActionJSScriptConfig | undefined => {
  const { eventCode, actionCode, command } = data

  const commandVariable = command?.length
    ? [
        {
          name: 'commandData',
          type: [
            {
              name: 'data',
              type: 'Array<any>',
            },
          ],
        },
      ]
    : []

  const commandFieldInfo = command?.length
    ? [{ key: 'srcObj.commandData', name: 'commandData', objectCode: 'context' }]
    : []

  if (
    eventCode &&
    [EVENT_CODE.ON_SEARCH, EVENT_CODE.ON_SOCKET_CHANGE, EVENT_CODE.AFTER_LOAD_CONFIG].includes(
      eventCode
    ) &&
    actionCode === ACTION_CODE.SET_VARIABLE_VALUE
  ) {
    return {
      examples: [AGGREGATION_COMMAND_RESULT_EXAMPLE],
      variables: [
        {
          name: 'srcObj',
          type: [
            ...commandVariable,
            {
              name: 'startDate',
              type: 'string',
              description: '',
            },
            {
              name: 'endDate',
              type: 'string',
              description: '',
            },
            {
              name: 'objectYSAFilters',
              type: 'any',
              description: 'Search assistant filters',
            },
            {
              name: 'staticFilters',
              type: [
                { name: 'objectX', type: 'any' },
                { name: 'objectY', type: 'any' },
              ],
              description: '',
            },
            {
              name: 'getRSqlBySearch',
              type: typeof getRSqlBySearch,
            },
          ],
        },
      ],
      fieldsInfo: [
        { key: 'srcObj.startDate', name: 'startDate', objectCode: 'context' },
        { key: 'srcObj.endDate', name: 'endDate', objectCode: 'context' },
        { key: 'srcObj.objectYSAFilters', name: 'endDate', objectCode: 'context' },
        { key: 'srcObj.staticFilters', name: 'staticFilters', objectCode: 'context' },
        ...commandFieldInfo,
      ],
    }
  }

  if (
    eventCode &&
    actionCode === ACTION_CODE.OPEN_VIEW &&
    [EVENT_CODE.ON_CELL_LEFT_CLICK, EVENT_CODE.ON_CELL_VALUE_DOUBLE_LEFT_CLICK].includes(eventCode)
  ) {
    return {
      examples: [ROSTER_DUTY_DEFAULT_FILTER_EXAMPLE],
      variables: [
        {
          name: 'srcObj',
          type: [
            ...commandVariable,
            {
              name: 'startDate',
              type: 'string',
              description: '',
            },
            {
              name: 'endDate',
              type: 'string',
              description: '',
            },
            {
              name: 'gridCellParams',
              type: [
                {
                  name: 'row',
                  type: [{ name: 'yElement', type: 'any', description: 'ObjectY object fields' }],
                },
                { name: 'field', type: 'string' },
              ],
              description: '',
            },
            {
              name: 'cellItem',
              type: 'any',
              description: 'ObjectX object fields',
            },
          ],
        },
      ],
      fieldsInfo: [
        { key: 'srcObj.startDate', name: 'startDate', objectCode: 'context' },
        { key: 'srcObj.endDate', name: 'endDate', objectCode: 'context' },
        { key: 'srcObj.gridCellParams', name: 'gridCellParams', objectCode: 'context' },
        { key: 'srcObj.cellItem', name: 'cellItem', objectCode: 'context' },
        ...commandFieldInfo,
      ],
    }
  }

  if (
    eventCode &&
    actionCode === ACTION_CODE.OPEN_VIEW &&
    [EVENT_CODE.ON_ROW_CLICK, EVENT_CODE.ON_ROW_DOUBLE_LEFT_CLICK].includes(eventCode)
  ) {
    return {
      examples: [],
      variables: [
        {
          name: 'srcObj',
          type: [
            ...commandVariable,
            {
              name: 'startDate',
              type: 'string',
              description: '',
            },
            {
              name: 'endDate',
              type: 'string',
              description: '',
            },
            {
              name: 'gridCellParams',
              type: [
                {
                  name: 'row',
                  type: [{ name: 'yElement', type: 'any', description: 'ObjectY object fields' }],
                },
                { name: 'field', type: 'string' },
              ],
              description: '',
            },
          ],
        },
      ],
      fieldsInfo: [
        { key: 'srcObj.startDate', name: 'startDate', objectCode: 'context' },
        { key: 'srcObj.endDate', name: 'endDate', objectCode: 'context' },
        { key: 'srcObj.gridCellParams', name: 'gridCellParams', objectCode: 'context' },
        ...commandFieldInfo,
      ],
    }
  }

  return undefined
}
